
    import { ModalBeforeOpenEvent } from '@/models/Interfaces';
    import SelectOption from '@/models/SelectOption';
    import _ from 'lodash';
    import { Options, Vue } from 'vue-class-component';
    import MessageBlock from '@/components/Helpers/MessageBlock.vue';
    import Swal from 'sweetalert2';
    import { api } from '@/services/Api';
    import { EmailsHistoryFilter } from '@/models/Emails';
    import { Newsletter, NewsletterSaveRequest } from '@/models/Newsletter';

    export type OnSaveCallback = (filter: EmailsHistoryFilter) => void;

    @Options<FilterModal>({
        props: {
            name: String,
        },
        components: {
            MessageBlock,
        },
    })
    export default class FilterModal extends Vue {
        public EmailsTemplates!: SelectOption[];
        public filter: EmailsHistoryFilter = new EmailsHistoryFilter();
        public templateId: string = '';
        public newTemplate: Newsletter = new Newsletter();
        public isTemplateUsed: boolean = false;
        public onSave: OnSaveCallback | null = null;
        public id: string = '';

        public async beforeOpen(event: ModalBeforeOpenEvent) {
            this.id = event.params?.id || 0;
            if (this.id) {
                var resp = await api.GetNewsletter(this.id);
                if (resp.Error || resp.Data == null) {
                    Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
                    return;
                }
                this.newTemplate = resp.Data;
            } else {
                this.newTemplate = new Newsletter();
            }
            this.filter = event.params.incomeFilter ? event.params.incomeFilter : new EmailsHistoryFilter();
            if (this.EmailsTemplates && this.filter.Keywords) {
                const foundId = this.EmailsTemplates.find((x) => x.text === this.filter.Keywords)?.id.toString();
                if (foundId) {
                    this.templateId = foundId;
                } else {
                    this.templateId = '';
                }
            }
            this.onSave = event.params?.onSave || null;
        }

        public async saveFilter() {
            if (this.onSave) {
                this.onSave(this.filter);
            }
        }

        public async modalSearch() {
            if (!this.newTemplate.Name) {
                Swal.fire({
                    icon: 'error',
                    text: this.$t('page.email-list.history-tab.newTemplate.alert.nameRequired') as string,
                });
                return;
            }
            if (this.isTemplateUsed) {
                const opts: any = new Promise((resolve) => {
                    resolve({
                        1: this.$t('page.email-template.alert.optionTemplateOnly'),
                        2: this.$t('page.email-template.alert.optionTemplateAndSchedul'),
                    });
                });

                const confirmation = await Swal.fire({
                    title: this.$t('page.email-template.alert.title') as string,
                    input: 'radio',
                    inputOptions: opts,
                    showCancelButton: true,
                    confirmButtonText: this.$t('page.automations.actions.continue') as string,
                    cancelButtonText: this.$t('modal.button.cancel') as string,
                });
                if (confirmation.isDismissed) {
                    return;
                }
                if (!confirmation.value) {
                    Swal.fire({
                        icon: 'error',
                        text: this.$t('page.email-template.alert.error') as string,
                    });
                    return;
                }
            }
            var newsletterRequest = new NewsletterSaveRequest();
            newsletterRequest.TemplateId = 0;
            newsletterRequest.HTML = this.newTemplate.HTML;
            newsletterRequest.Name = this.newTemplate.Name;
            newsletterRequest.IsTextTemplate = true;
            const resp = this.newTemplate.Id ? await api.SaveTextNewsletter(this.newTemplate) : await api.AddNewsletter(newsletterRequest);
            if (resp.Error || !resp.Data) {
                Swal.fire(resp.ErrorMessage || 'Oops..', '', 'warning');
                return;
            }

            this.saveFilter();
            this.$emit('onCreateNewsletter');
        }
    }
